export default "__VITE_ASSET__CQD6P$uU__"